import {
	_NEVER,
	BaseQueryFn,
	createApi,
	EndpointBuilder,
	fakeBaseQuery
} from "@reduxjs/toolkit/query/react"
import { EchoTag } from "./api/util/EchoTag"
import genesisCareEndpoints from "./Echo.GenesisCare.Query"
import spireEndpoints from "./Echo.Spire.Query"

export type EchoEndpointBuilder = EndpointBuilder<
	BaseQueryFn<void, typeof _NEVER, unknown, {}, {}>,
	EchoTag,
	"echo"
>

const echoSlice = createApi({
	reducerPath: "echo",
	baseQuery: fakeBaseQuery(),
	endpoints: () => ({}),
	tagTypes: Object.values(EchoTag)
}).injectEndpoints({
	endpoints: genesisCareEndpoints
}).injectEndpoints({
	endpoints: spireEndpoints
})

export default echoSlice
